var _circle, _path, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxVerifyState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0003,
    cy: 9.99935,
    r: 8.33333,
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 7.39648C8.4375 6.53354 9.13706 5.83398 10 5.83398C10.8629 5.83398 11.5625 6.53354 11.5625 7.39648C11.5625 7.96936 11.2542 8.47022 10.7945 8.74222C10.3984 8.97657 10 9.33208 10 9.79232V10.834",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0003,
    cy: 13.3333,
    r: 0.833333,
    fill: "#2058E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4056_19668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxVerifyState);
export default __webpack_public_path__ + "static/media/BoxVerifyState.e94270f93d28e4b201cffb552b447b53.svg";
export { ForwardRef as ReactComponent };